module.exports = __webpack_public_path__ + "media/images/certificate_logo@2x-5d13693a636bc56bb37404d366b4f9d0.png";